if (!customElements.get('knox-paths')) customElements.define('knox-paths', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort();
  this.controller = new AbortController();
  const signal = this.controller.signal;
  const measure = () => {
   const explorer = document.querySelector('knox-home-explorer');
   const tabs = explorer?.querySelector('.khe-top');
   const reserve = tabs ? tabs.getBoundingClientRect().height + parseFloat(getComputedStyle(explorer).paddingTop) + 10 : 96;
   if (window.scrollY < 2 || this.documentTop === undefined) this.documentTop = this.getBoundingClientRect().top + window.scrollY;
   const top = this.documentTop;
   this.style.setProperty('--kn-screen', Math.max(0, Math.min(940, window.innerHeight - top - reserve)) + 'px');
   this.querySelectorAll('.kn-path').forEach(panel => {
    const scene = panel.querySelector('.kn-scene');
    if (!scene) return;
    const box = scene.getBoundingClientRect();
    const max = matchMedia('(min-width:1500px) and (min-height:820px)').matches ? 400 : 320;
    const artSize = Math.max(0, Math.floor(Math.min(box.width, box.height, max)));
    panel.style.setProperty('--kn-art-size', artSize + 'px');
    panel.style.setProperty('--kn-art-wing', Math.min(170, Math.max(0, (box.width - artSize) / 2 - 40)) + 'px');
   });
  };
  this.resize = () => { cancelAnimationFrame(this.resizeFrame); this.resizeFrame = requestAnimationFrame(measure); };
  this.resize();
  window.addEventListener('resize', this.resize, { signal });
  document.fonts.ready.then(() => this.isConnected && this.resize());
  this.observer = new ResizeObserver(() => { if (window.scrollY < 2) this.resize(); });
  const header = document.querySelector('.site-header');
  const tabs = document.querySelector('knox-home-explorer .khe-top');
  if (header) this.observer.observe(header);
  if (tabs) this.observer.observe(tabs);
  this.querySelectorAll('.kn-path').forEach(panel => {
   panel.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    const box = panel.getBoundingClientRect();
    panel.style.setProperty('--mx', ((event.clientX - box.left) / box.width - .5) * 6 + 'px');
    panel.style.setProperty('--my', ((event.clientY - box.top) / box.height - .5) * 4 + 'px');
   }, { signal });
   panel.addEventListener('pointerleave', () => { panel.style.setProperty('--mx', '0px'); panel.style.setProperty('--my', '0px'); }, { signal });
  });
 }
 disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.resizeFrame); }
});